import { create } from "zustand";

interface UIState {
  // Menu state
  isMenuOpen: boolean;
  toggleMenu: () => void;
  setMenuOpen: (open: boolean) => void;

  // Preloader state
  isPreloaderVisible: boolean;
  hidePreloader: () => void;

  // Slide theme state (for adaptive header colors)
  isDarkSlide: boolean;
  setIsDarkSlide: (isDark: boolean) => void;

  // Section detection state (for adaptive header colors)
  isInHeroSection: boolean;
  setIsInHeroSection: (inHero: boolean) => void;
}

const useUIStore = create<UIState>()((set) => ({
  // Menu state
  isMenuOpen: false,
  toggleMenu: () => set((state) => ({ isMenuOpen: !state.isMenuOpen })),
  setMenuOpen: (open) => set({ isMenuOpen: open }),

  // Preloader state
  isPreloaderVisible: true,
  hidePreloader: () => set({ isPreloaderVisible: false }),

  // Slide theme state (default false = white text, matches most slides)
  isDarkSlide: false,
  setIsDarkSlide: (isDark) => set({ isDarkSlide: isDark }),

  // Section detection state (default false - only set to true by useSectionDetection on Home page)
  isInHeroSection: false,
  setIsInHeroSection: (inHero) => set({ isInHeroSection: inHero }),
}));

// Export custom hooks with selectors (best practice for re-render optimization)
export const useIsMenuOpen = () => useUIStore((s) => s.isMenuOpen);
export const useIsPreloaderVisible = () =>
  useUIStore((s) => s.isPreloaderVisible);
export const useToggleMenu = () => useUIStore((s) => s.toggleMenu);
export const useSetMenuOpen = () => useUIStore((s) => s.setMenuOpen);
export const useHidePreloader = () => useUIStore((s) => s.hidePreloader);
export const useIsDarkSlide = () => useUIStore((s) => s.isDarkSlide);
export const useSetIsDarkSlide = () => useUIStore((s) => s.setIsDarkSlide);
export const useIsInHeroSection = () => useUIStore((s) => s.isInHeroSection);
export const useSetIsInHeroSection = () =>
  useUIStore((s) => s.setIsInHeroSection);

export default useUIStore;
